import React from 'react';
import { normalizePageBorderImageOpacity } from '../../../AppComponents/pageBackgroundImageStyle.js';
import { formatBorderImageSlice } from '../Utils/borderFrameUtils.js';

const BorderWrapper = ({
  borderImage = '',
  borderWidth = 0,
  borderImageOpacity = 1,
  borderImageSlice = 30,
  borderImagePreset,
  borderImageRepeat = 'round',
  innerPadding = 0,
  Styles = {},
  classNames = '',
  backgroundColor = '#fff',
  childrenBackgroundColor = '',
  children,
}) => {
  if (!borderImage) return <>{children}</>;

  const bw = typeof borderWidth === 'number'
    ? borderWidth
    : parseInt(borderWidth, 10) || 0;
  const opacity = normalizePageBorderImageOpacity(borderImageOpacity);

  const wrapperStyle = {
    position: 'relative',
    boxSizing: 'border-box',
    padding: bw + Math.max(0, Number(innerPadding) || 0),
    backgroundColor,
    ...Styles,
  };

  const borderImageLayerStyle = {
    position: 'absolute',
    inset: 0,
    boxSizing: 'border-box',
    border: `${bw}px solid transparent`,
    borderImage: `url("${borderImage}") ${formatBorderImageSlice(borderImageSlice, borderImagePreset)} ${borderImageRepeat || 'round'}`,
    opacity,
    pointerEvents: 'none',
    zIndex: 0,
  };

  const innerFillStyle = {
    position: 'absolute',
    top: bw,
    left: bw,
    right: bw,
    bottom: bw,
    backgroundColor,
    pointerEvents: 'none',
    zIndex: 1,
  };

  const contentStyle = {
    position: 'relative',
    zIndex: 2,
    width: '100%',
    height: '100%',
    backgroundColor: childrenBackgroundColor || 'transparent',
  };

  return (
    <div className={classNames} style={wrapperStyle}>
      <div aria-hidden="true" style={borderImageLayerStyle} />
      <div style={innerFillStyle} />
      <div style={contentStyle}>{children}</div>
    </div>
  );
};

export default BorderWrapper;
